/*
* Scroll events manager
*/
$.fn.ScrollEvents = function(axis) {
  let self = this

  if (self.data('scroll-events')) {
    return self.data('scroll-events')
  }

  if (typeof axis == 'undefined') {
    axis = 'vertical'
  }

  self.axis = axis;
  self.callbacks = []
  self.requested = false
  self.last_position = 0

  self.add = function(callback) {
    self.addCallback(callback)
  }

  self.addCallback = function(callback) {
    if (callback != undefined) {
      self.callbacks.push(callback)
    }
  }

  self.removeCallback = function(callback) {
    if (callback != undefined) {
      let index = self.callbacks.length
      for (let i = index - 1; i >= 0; i--) {
        if (self.callbacks[i] == callback) {
          self.callbacks.splice(i, 1)
        }
      }
    }
  }

  self.scrolled = function() {
    if (self.requested) {
      return
    }
    self.requested = true
    requestAnimationFrame(function() {
      let current_position = (self.axis == 'vertical') ? self.scrollTop() : self.scrollLeft(),
      direction = (current_position >= self.last_position) ? (self.axis == 'vertical' ? 'down' : 'right') : (self.axis == 'vertical' ? 'up' : 'left')
      self.callbacks.forEach(function(callback) {
        callback(current_position, direction)
        self.last_position = current_position
      })
      self.requested = false
    })
  }

  self.kill = function() {
    self.off('scroll load orientationchange resize', self.scrolled)
  }

  return function() {
    self.on('scroll load orientationchange resize', self.scrolled)
    self.last_position = (self.axis == 'vertical') ? self.scrollTop() : self.scrollLeft()
    self.data('scroll-events', self)
    return self
  }()
}
